(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["best-sellers"] && !Shopify.designMode) return;
  try {
    
  (function () {

    // ───── Slider behaviour ─────
    document.querySelectorAll('.psp-slider').forEach(function (slider) {
      const viewport = slider.querySelector('.psp-slider__viewport');
      const track    = slider.querySelector('.psp-slider__track');
      const prevBtn  = slider.querySelector('.psp-slider__nav--prev');
      const nextBtn  = slider.querySelector('.psp-slider__nav--next');
      if (!viewport || !track) return;

      function step() {
        const card = track.querySelector('.psp-card');
        if (!card) return 0;
        const gap = parseInt(window.getComputedStyle(track).gap, 10) || 20;
        return card.offsetWidth + gap;
      }
      function atEnd() {
        return viewport.scrollLeft + viewport.clientWidth >= viewport.scrollWidth - 4;
      }
      function atStart() {
        return viewport.scrollLeft <= 2;
      }
      function next() {
        if (atEnd()) viewport.scrollTo({ left: 0, behavior: 'smooth' });
        else         viewport.scrollBy({ left: step(), behavior: 'smooth' });
      }
      function prev() {
        if (atStart()) viewport.scrollTo({ left: viewport.scrollWidth, behavior: 'smooth' });
        else           viewport.scrollBy({ left: -step(), behavior: 'smooth' });
      }
      if (prevBtn) prevBtn.addEventListener('click', prev);
      if (nextBtn) nextBtn.addEventListener('click', next);

      const autoplay  = slider.dataset.autoplay === 'true';
      const interval  = parseInt(slider.dataset.interval, 10) || 4000;
      let   timer     = null;
      function startAuto() { if (autoplay) { stopAuto(); timer = setInterval(next, interval); } }
      function stopAuto()  { if (timer) { clearInterval(timer); timer = null; } }

      slider.addEventListener('mouseenter', stopAuto);
      slider.addEventListener('mouseleave', startAuto);
      viewport.addEventListener('touchstart', stopAuto, { passive: true });
      viewport.addEventListener('touchend',  function () { setTimeout(startAuto, 2500); }, { passive: true });
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stopAuto(); else startAuto();
      });

      startAuto();
    });

    // ───── Card behaviour (variant change + ajax add-to-cart) ─────
    document.querySelectorAll('.psp-card').forEach(function (card) {
      const select    = card.querySelector('.psp-card__variant-select');
      const hiddenId  = card.querySelector('.psp-card__variant-id');
      const priceEl   = card.querySelector('.psp-card__price');
      const compareEl = card.querySelector('.psp-card__compare');
      const savingsEl = card.querySelector('.psp-card__savings-amount');
      if (!select) return;

      function fmt(cents) { return '₹' + Math.round(cents / 100); }

      select.addEventListener('change', function (e) {
        const opt = e.target.options[e.target.selectedIndex];
        const variantId = opt.value;
        const price   = parseInt(opt.dataset.price, 10)   || 0;
        const compare = parseInt(opt.dataset.compare, 10) || 0;
        const savings = parseInt(opt.dataset.savings, 10) || 0;

        hiddenId.value = variantId;
        if (priceEl) priceEl.textContent = fmt(price);
        if (compareEl) {
          if (compare > price) {
            compareEl.textContent = fmt(compare);
            compareEl.style.display = '';
          } else {
            compareEl.style.display = 'none';
          }
        }
        if (savingsEl) savingsEl.textContent = fmt(savings);
      });

      const btn = card.querySelector('.psp-card__add-btn');
      if (!btn) return;

      function handleAdd(e) {
        if (e) { e.preventDefault(); if (e.stopImmediatePropagation) e.stopImmediatePropagation(); }

        const variantInput = card.querySelector('.psp-card__variant-id');
        const variantId = variantInput ? variantInput.value : null;
        if (!variantId) {
          console.error('PSP best-sellers: no variant ID on card', card);
          btn.textContent = 'NO VARIANT';
          setTimeout(function () { btn.textContent = 'ADD TO CART'; }, 1800);
          return;
        }

        const originalText = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'ADDING...';

        // Ask Shopify to also re-render Dawn's header/cart sections in the same response.
        // This is the official Section Rendering API — works on Dawn and any theme that
        // exposes these sections; harmless on themes that don't.
        const renderSections = ['cart-icon-bubble', 'cart-live-region-text', 'cart-drawer', 'cart-notification', 'header'];

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            items: [{ id: parseInt(variantId, 10), quantity: 1 }],
            sections: renderSections.join(','),
            sections_url: window.location.pathname
          })
        })
          .then(function (res) {
            return res.json().then(function (data) {
              if (!res.ok) {
                throw new Error(data.description || data.message || ('HTTP ' + res.status));
              }
              return data;
            });
          })
          .then(function (item) {
            console.log('PSP best-sellers: added to cart', item);
            btn.textContent = '✓ ADDED';

            // Dawn path: if the response contains rendered sections, swap them into the DOM.
            // This is how Dawn's own product form refreshes the cart icon bubble + cart drawer.
            if (item.sections) {
              Object.keys(item.sections).forEach(function (sectionId) {
                const html = item.sections[sectionId];
                if (!html) return;
                const newDoc = new DOMParser().parseFromString(html, 'text/html');
                // Try ID match first (e.g. cart-icon-bubble), then class match
                const newEl = newDoc.getElementById(sectionId) ||
                              newDoc.querySelector('[data-section-id="' + sectionId + '"]') ||
                              newDoc.body.firstElementChild;
                const currentEl = document.getElementById(sectionId) ||
                                  document.querySelector('[data-section-id="' + sectionId + '"]') ||
                                  document.getElementById('shopify-section-' + sectionId);
                if (newEl && currentEl) {
                  currentEl.innerHTML = newEl.innerHTML;
                }
              });
            }

            // Tell Dawn's cart-notification / cart-drawer custom elements to refresh.
            const cartNotif  = document.querySelector('cart-notification');
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartNotif && typeof cartNotif.renderContents === 'function') {
              try { cartNotif.renderContents(item); } catch (_) {}
            } else if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
              try { cartDrawer.renderContents(item); } catch (_) {}
            }

            // Surgical cart-badge update. ONLY touches leaf elements tagged
            // [data-cart-count] or .cart-products-count — never the wrapper
            // <div id="CartCount_sticky">, so the "Cart" label stays intact.
            // The real work is done by the listener in header-model-2.liquid;
            // this is a safety backup in case the listener isn't installed yet.
            fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                const count = cart.item_count;

                document.querySelectorAll('[data-cart-count], .cart-products-count').forEach(function (el) {
                  if (el.children.length === 0) el.textContent = count;
                });

                // Dispatch standard cart events — header-model-2.liquid's listener
                // picks these up and handles count + mini-cart refresh in one place.
                document.dispatchEvent(new CustomEvent('cart:updated',      { detail: cart }));
                document.dispatchEvent(new CustomEvent('cart:refresh',      { detail: cart }));
                document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: item }));
                console.log('PSP best-sellers: cart count painted →', count);
              })
              .catch(function () {});

            // Try opening Dawn-style cart drawer if the theme has one
            const drawer = document.querySelector('cart-drawer');
            if (drawer && typeof drawer.open === 'function') {
              try { drawer.open(); } catch (_) {}
            }
            // Or click a common cart-drawer trigger if one exists
            const drawerTrig = document.querySelector('[data-cart-drawer-toggle], .js-drawer-open-cart, .cart-drawer-trigger');
            if (drawerTrig) { try { drawerTrig.click(); } catch (_) {} }

            setTimeout(function () {
              btn.textContent = originalText;
              btn.disabled = false;
            }, 1400);
          })
          .catch(function (err) {
            console.error('PSP best-sellers: add to cart failed —', err);
            const msg = (err && err.message ? err.message : 'ERROR').substring(0, 24);
            btn.textContent = msg.toUpperCase();
            setTimeout(function () {
              btn.textContent = originalText;
              btn.disabled = false;
            }, 2400);
          });
      }

      btn.addEventListener('click', handleAdd);
      // Belt and braces: also intercept any accidental form submit
      card.addEventListener('submit', handleAdd);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
